import { FormsService } from './forms.service';
import * as $ from "jquery";
var FinanceCalculatorService = /** @class */ (function () {
    function FinanceCalculatorService() {
        this.apiUrl = '';
        this.formsService = FormsService.getInstance();
    }
    FinanceCalculatorService.getInstance = function () {
        if (!FinanceCalculatorService.instance) {
            FinanceCalculatorService.instance = new FinanceCalculatorService();
        }
        return FinanceCalculatorService.instance;
    };
    FinanceCalculatorService.prototype.setBaseUrl = function (baseUrl) {
        this.apiUrl = baseUrl || window.location.origin;
    };
    // DETECT CALCULATOR
    FinanceCalculatorService.prototype.detect = function (form) {
        switch (form.id) {
            case 'calculator-access-finance':
                this.doAccessFinanceCalculator(form);
                break;
            case 'calculator-vaf-finance-calculator':
                this.doVAFMonthly(form);
                break;
            default:
                break;
        }
    };
    // CALCULATOR
    FinanceCalculatorService.prototype.doVAFMonthly = function (form) {
        //debugger;
        var loader = document.querySelectorAll("div.form__loader-finance-access-fields-container");
        [].slice.call(loader).forEach(function (div) {
            div.classList.remove('hidden');
        });
        var purchaseprice = form.querySelector('input[name=purchase_price]');
        var deposit = form.querySelector('input[name=deposit]');
        var term = form.querySelector('input[name=term]');
        var balloon = form.querySelector('input[name=balloon]');
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var output_loan = document.querySelectorAll('span.js-calculator-total-paid-vaf-business');
        var output_estimate = document.querySelectorAll('span.js-calculator-estimated-repayment-vaf-business');
        var amount_finance = document.querySelectorAll('span.js-calculator-amount-to-finance-vaf-business');
        var interest_amount = document.querySelectorAll('span.js-calculator-intereset-amount-vaf-business');
        var balloon_amount = document.querySelectorAll('span.js-calculator-balloon-amount-vaf-business');
        var answer = this.VAFCalculator(purchaseprice.value, deposit.value, balloon.value, 0, term.value, interest.value);
        [].slice.call(amount_finance).forEach(function (div) {
            div.innerHTML = answer.financeAmount;
        });
        [].slice.call(interest_amount).forEach(function (div) {
            div.innerHTML = answer.totalInterest;
        });
        [].slice.call(balloon_amount).forEach(function (div) {
            div.innerHTML = answer.ballonAmount;
        });
        [].slice.call(output_loan).forEach(function (div) {
            div.innerHTML = answer.loanAmount;
        });
        [].slice.call(output_estimate).forEach(function (div) {
            div.innerHTML = answer.monthlyRepayment;
        });
        [].slice.call(loader).forEach(function (div) {
            div.classList.add('hidden');
        });
    };
    FinanceCalculatorService.prototype.VAFCalculator = function (purchaseprice, deposit, baloonpercentage, baloonamount, loanterm, interest) {
        if (purchaseprice === void 0) { purchaseprice = 0; }
        if (deposit === void 0) { deposit = 0; }
        if (baloonpercentage === void 0) { baloonpercentage = 0; }
        if (baloonamount === void 0) { baloonamount = 0; }
        if (loanterm === void 0) { loanterm = 0; }
        if (interest === void 0) { interest = 11.75; }
        if (purchaseprice == 0) {
            return {
                monthlyRepayment: this.formatter(0),
                loanAmount: this.formatter(0)
            };
        }
        var monthlyRepayment = 0;
        var loanAmount = 0;
        var getLoan = 0;
        var getFinalLoan = 0;
        var getPayments = 0;
        var getDeposit = deposit;
        var getBalloonAmt = baloonamount;
        var getAmtAdminFee = 68.40;
        var getInterest = 0;
        var i = interest;
        i = i / 100.0;
        i /= 12;
        var pow = 1;
        var j = 0;
        while (j < loanterm) {
            pow = pow * (1 + i);
            j++;
        }
        getLoan = purchaseprice - deposit;
        getBalloonAmt = baloonpercentage * purchaseprice / 100;
        getFinalLoan = (getLoan - getBalloonAmt / pow);
        getPayments = (getFinalLoan * pow * i) / (pow - 1);
        // monthlyRepayment = getPayments + getAmtAdminFee;
        monthlyRepayment = getPayments;
        loanAmount = (getPayments + getAmtAdminFee) * loanterm;
        getInterest = (((getPayments) * loanterm) + getBalloonAmt) - getLoan;
        if (baloonpercentage > 0) {
            loanAmount = getBalloonAmt + loanAmount;
        }
        if (purchaseprice === deposit) {
            getLoan = 0;
            monthlyRepayment = 0;
            loanAmount = 0;
            getBalloonAmt = 0;
            getInterest = 0;
        }
        return {
            financeAmount: getLoan,
            monthlyRepayment: this.formatter(monthlyRepayment),
            loanAmount: this.formatter(loanAmount),
            ballonAmount: this.formatter(getBalloonAmt),
            totalInterest: this.formatter(getInterest),
        };
    };
    FinanceCalculatorService.prototype.doAccessFinanceCalculator = function (form) {
        var amountToFinance = form.querySelector('input[name=finance-amount]');
        var averageDailyBalance = form.querySelector('input[name=avarage-daily-balance]');
        var term = form.querySelector('input[name=term]');
        var balloonPercentage = form.querySelector('input[name=balloon-percentage]');
        var interest = form.querySelector('input[name=interest-rate]');
        var paymentFrequency = form.querySelector("input[name=payment-frequency]:checked");
        this.AccessFinanceCalculator(amountToFinance.value, balloonPercentage.value, term.value, interest.value, averageDailyBalance.value, paymentFrequency.dataset.value);
    };
    FinanceCalculatorService.prototype.AccessFinanceCalculator = function (amountToFinance, baloonpercentage, term, interest, averageDailyBalance, paymentFrequency) {
        var _this = this;
        if (amountToFinance === void 0) { amountToFinance = 0; }
        if (baloonpercentage === void 0) { baloonpercentage = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        if (averageDailyBalance === void 0) { averageDailyBalance = 0; }
        if (paymentFrequency === void 0) { paymentFrequency = 'MONTHLY'; }
        this.updateLabel(paymentFrequency);
        var postData = {
            'amountToFinance': Number(amountToFinance),
            'interestRate': Number(interest),
            'balloonPercent': Number(baloonpercentage),
            'term': Number(term),
            'averageDailyBalance': Number(averageDailyBalance),
            'paymentFrequency': paymentFrequency === 'MONTHLY' ? 1 : 12,
        };
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var loader = document.querySelectorAll("div.form__loader-finance-access-fields-container");
        var fieldsContainer = document.querySelectorAll("div.page-fields-container-finance-access-calculator");
        var ErrorView = document.querySelectorAll('div.access-finance-error');
        [].slice.call(loader).forEach(function (div) {
            div.classList.remove('hidden');
        });
        var url = this.apiUrl + "/leadsutils/vafafcalc";
        this.formsService.postForm(url, postData, _config).then(function (response) {
            if (response.status && response.status === 200 && response.data) {
                _this.displayCalculations(response.data);
            }
            else {
                [].slice.call(fieldsContainer).forEach(function (div) {
                    div.classList.add('hidden');
                });
                [].slice.call(ErrorView).forEach(function (div) {
                    div.classList.remove('hidden');
                });
            }
            [].slice.call(loader).forEach(function (div) {
                div.classList.add('hidden');
            });
        })
            .catch(function (response) {
            [].slice.call(ErrorView).forEach(function (div) {
                div.classList.remove('hidden');
            });
            [].slice.call(fieldsContainer).forEach(function (div) {
                div.classList.add('hidden');
            });
            [].slice.call(loader).forEach(function (div) {
                div.classList.add('hidden');
            });
        });
    };
    FinanceCalculatorService.prototype.displayCalculations = function (calculationsData) {
        var display_monthly_repayment = document.querySelectorAll('span.finance-access-monthly-repayment');
        var display_total_term_rapayment = document.querySelectorAll('span.finance-access-total-term-repayment');
        var display_approximate_finance_charges_term = document.querySelectorAll('span.finance-access-approximate-finance-charges-term');
        var display_new_approx_avg_monthly_repayment = document.querySelectorAll('span.finance-access-new-approx-avg-monthly-repayment');
        var display_average_saving_per_month_term = document.querySelectorAll('span.finance-access-average-saving-per-month-term');
        var display_new_approx_interest_rate = document.querySelectorAll('span.finance-access-new-approx-int-rate');
        var display_new_total_repayments_term = document.querySelectorAll('span.finance-access-new-total-repayments-term');
        var display_interest_earnings_reduction_term = document.querySelectorAll('span.finance-access-interest-earnings-reduction-term');
        if (!calculationsData.message.includes('OK')) {
            var fieldsContainer = document.querySelectorAll("div.page-fields-container-finance-access-calculator");
            var ErrorView = document.querySelectorAll('div.access-finance-error');
            [].slice.call(fieldsContainer).forEach(function (div) {
                div.classList.add('hidden');
            });
            [].slice.call(ErrorView).forEach(function (div) {
                div.classList.remove('hidden');
            });
            return;
        }
        // -- Monthly Repayment -- //
        var instalmentAmount = this.formatter(calculationsData.instalmentAmount);
        [].slice.call(display_monthly_repayment).forEach(function (div) {
            div.innerHTML = instalmentAmount;
        });
        [].slice.call(display_total_term_rapayment).forEach(function (div) {
            div.innerHTML = 0.00;
        });
        var totalInstalments = this.formatter(calculationsData.totalInstalments);
        // -- Total Term Repayment -- //
        [].slice.call(display_total_term_rapayment).forEach(function (div) {
            div.innerHTML = totalInstalments;
        });
        var totalInterest = this.formatter(calculationsData.totalInterest);
        // -- Approxiamte Finance Charges Over Term -- //
        [].slice.call(display_approximate_finance_charges_term).forEach(function (div) {
            div.innerHTML = totalInterest;
        });
        // -- ADB -- //
        var averageReducedInstalment = this.formatter(calculationsData.averageReducedInstalment);
        // -- New Approximate Average Monthly Repayment -- //
        [].slice.call(display_new_approx_avg_monthly_repayment).forEach(function (div) {
            div.innerHTML = averageReducedInstalment;
        });
        // -- Average Saving Per Month Over the Term -- //
        var averageInstalmentReduction = this.formatter(calculationsData.averageInstalmentReduction);
        [].slice.call(display_average_saving_per_month_term).forEach(function (div) {
            div.innerHTML = averageInstalmentReduction;
        });
        // -- New Approximate Interst Rate -- //
        [].slice.call(display_new_approx_interest_rate).forEach(function (div) {
            div.innerHTML = calculationsData.effectiveDiscountedRate;
        });
        // -- New Total Repayments Over the Term -- //
        var totalReducedInstalments = this.formatter(calculationsData.totalReducedInstalments);
        [].slice.call(display_new_total_repayments_term).forEach(function (div) {
            div.innerHTML = totalReducedInstalments;
        });
        // -- Interest Earnings Reduction Over the Term -- //
        var totalCreditInterest = this.formatter(calculationsData.totalCreditInterest);
        [].slice.call(display_interest_earnings_reduction_term).forEach(function (div) {
            div.innerHTML = totalCreditInterest;
        });
    };
    // RESET VALUES	- OUTPUTS
    FinanceCalculatorService.prototype.resetValues = function (form) {
        switch (form.id) {
            case 'calculator-vaf-finance-calculator':
                var output_loan = document.querySelectorAll('span.js-calculator-total-paid-vaf-business');
                var output_estimate = document.querySelectorAll('span.js-calculator-estimated-repayment-vaf-business');
                var amount_finance = document.querySelectorAll('span.js-calculator-amount-to-finance-vaf-business');
                var interest_amount = document.querySelectorAll('span.js-calculator-intereset-amount-vaf-business');
                var balloon_amount = document.querySelectorAll('span.js-calculator-balloon-amount-vaf-business');
                [].slice.call(amount_finance).forEach(function (div) {
                    div.innerHTML = 0;
                });
                [].slice.call(interest_amount).forEach(function (div) {
                    div.innerHTML = 0;
                });
                [].slice.call(balloon_amount).forEach(function (div) {
                    div.innerHTML = 0;
                });
                [].slice.call(output_loan).forEach(function (div) {
                    div.innerHTML = 0;
                });
                [].slice.call(output_estimate).forEach(function (div) {
                    div.innerHTML = 0;
                });
                break;
            case 'calculator-access-finance':
                this.updateLabel();
                var display_monthly_repayment = document.querySelectorAll('span.finance-access-monthly-repayment');
                var display_total_term_rapayment = document.querySelectorAll('span.finance-access-total-term-repayment');
                var display_approximate_finance_charges_term = document.querySelectorAll('span.finance-access-approximate-finance-charges-term');
                var display_new_approx_avg_monthly_repayment = document.querySelectorAll('span.finance-access-new-approx-avg-monthly-repayment');
                var display_average_saving_per_month_term = document.querySelectorAll('span.finance-access-average-saving-per-month-term');
                var display_new_approx_interest_rate = document.querySelectorAll('span.finance-access-new-approx-int-rate');
                var display_new_total_repayments_term = document.querySelectorAll('span.finance-access-new-total-repayments-term');
                var display_interest_earnings_reduction_term = document.querySelectorAll('span.finance-access-interest-earnings-reduction-term');
                [].slice.call(display_monthly_repayment).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(display_total_term_rapayment).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(display_approximate_finance_charges_term).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(display_new_approx_avg_monthly_repayment).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(display_average_saving_per_month_term).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(display_new_approx_interest_rate).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(display_new_total_repayments_term).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(display_interest_earnings_reduction_term).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            default:
                break;
        }
    };
    // FORMATTERS
    FinanceCalculatorService.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');
    };
    FinanceCalculatorService.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    FinanceCalculatorService.prototype.pmt = function (rate, per, nper, pv, fv) {
        if (rate === void 0) { rate = 0; }
        if (per === void 0) { per = 0; }
        if (nper === void 0) { nper = 0; }
        if (pv === void 0) { pv = 0; }
        if (fv === void 0) { fv = 0; }
        var pmt_value, x;
        if ((per === 0) || (nper === 0)) {
            return 0;
        }
        rate = rate / (per * 100);
        if (rate === 0) {
            pmt_value = -(fv + pv) / nper;
        }
        else {
            x = Math.pow(1 + rate, nper);
            pmt_value = -((rate * (fv + x * pv)) / (-1 + x));
        }
        pmt_value = this.round(pmt_value, 2);
        return pmt_value;
    };
    FinanceCalculatorService.prototype.fv = function (rate, periods, payment, value, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (payment === void 0) { payment = 0; }
        if (value === void 0) { value = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        value = value || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = value + payment * periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = value * term + payment * (1 + rate) * (term - 1) / rate;
            }
            else {
                result = value * term + payment * (term - 1) / rate;
            }
        }
        return -result;
    };
    FinanceCalculatorService.prototype.validateFinanceCalculator = function (event, button) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var formValid = true;
        var value = field.value;
        var fieldValue = value.replace(/ /g, '');
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        var purchaseMin = 100000;
        var purchaseMax = 10000000;
        // removeErrors
        this.clearCalculatorErrors(event);
        // required
        if (required == "true") {
            if (fieldValue.length == 0 || fieldValue == '' || fieldValue == 0) {
                formValid = false;
                if (minimum) {
                    if (maximum) {
                        if (title) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                        }
                        else {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                        }
                    }
                    else {
                        this.validateCalculatorError(event, 'Enter the minimum value of ' + this.formatNumbers(minimum));
                    }
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount');
                }
            }
        }
        // min
        if (minimum > parseFloat(fieldValue)) {
            formValid = false;
            if (title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
            }
            else if (!title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
            }
            else if (!title && !maximum) {
                this.validateCalculatorError(event, 'Enter the minimum value of ' + this.formatNumbers(minimum));
            }
        }
        // max
        if (maximum > 0) {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
            }
        }
        else {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0');
                }
            }
        }
        // greater than
        if (greaterThan) {
            var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
            if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                formValid = false;
                this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
            }
        }
        // less than
        if (lessThan) {
            var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
            if (fieldsLessThan.length > 1) {
                var amount_1 = 0;
                $(fieldsLessThan).each(function (index) {
                    var valueElement = $(this).val();
                    if (!valueElement) {
                        amount_1 = amount_1 + 0;
                    }
                    else {
                        amount_1 = amount_1 + parseFloat(valueElement);
                    }
                });
                if (parseFloat(fieldValue) >= amount_1) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
            else {
                if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
        }
        if (field.name === 'deposit') {
            var purchasePrice = $(field).closest('form').find('input[name=purchase_price]').val();
            //let purchasePrice = parseFloat($('input[name=purchase_price]').attr('data-value'));
            var depositValue = parseFloat(fieldValue);
            purchasePrice = parseFloat(purchasePrice);
            if (!isNaN(depositValue) && depositValue > purchasePrice) {
                formValid = false;
                this.validateCalculatorError(event, 'Deposit cannot be more than the purchase price');
            }
            else if (purchasePrice === depositValue && purchasePrice >= purchaseMin && purchasePrice <= purchaseMax) {
                this.clearSpecificError('purchase_price');
                this.clearSpecificError('deposit');
            }
            else if (depositValue < purchasePrice && purchasePrice > purchaseMin && purchasePrice < purchaseMax) {
                this.clearSpecificError('purchase_price');
                this.clearSpecificError('deposit');
            }
            else if (purchasePrice === purchaseMax && depositValue === purchaseMax) {
                this.clearSpecificError('purchase_price');
                this.clearSpecificError('deposit');
            }
            else if ((purchasePrice > purchaseMax || purchasePrice < purchaseMin) && purchasePrice === depositValue) {
                this.clearSpecificError('deposit');
                this.clearSpecificError('purchase_price');
                this.addSpecificError('purchase_price', 'Enter an amount between ' + this.formatNumbers(purchaseMin) + ' and ' + this.formatNumbers(purchaseMax));
            }
        }
        if (field.name === 'purchase_price') {
            //let depositValue  = parseFloat($('input[name=deposit]').attr('data-value'));
            var depositValue = $(field).closest('form').find('input[name=deposit]').val();
            depositValue = parseFloat(depositValue);
            var purchasePrice = parseFloat(fieldValue);
            if (!isNaN(purchasePrice) && purchasePrice < depositValue) {
                formValid = false;
                this.validateCalculatorError(event, 'Purchase price must be more than the deposit');
            }
            else if (purchasePrice === depositValue && purchasePrice >= purchaseMin && purchasePrice <= purchaseMax) {
                this.clearSpecificError('deposit');
                this.clearSpecificError('purchase_price');
            }
            else if (purchasePrice > depositValue && purchasePrice > purchaseMin && purchasePrice < purchaseMax) {
                this.clearSpecificError('purchase_price');
                this.clearSpecificError('deposit');
            }
            else if (purchasePrice === purchaseMax && depositValue === purchaseMax) {
                this.clearSpecificError('purchase_price');
                this.clearSpecificError('deposit');
            }
            else if ((purchasePrice > purchaseMax || purchasePrice < purchaseMin) && purchasePrice === depositValue) {
                this.clearSpecificError('purchase_price');
                this.clearSpecificError('deposit');
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
            }
        }
        return formValid;
    };
    FinanceCalculatorService.prototype.clearSpecificError = function (fieldName) {
        var inputElement = $("input[name=" + fieldName + "]");
        var closestGroup = inputElement.closest('.finance-calculator-form__group');
        closestGroup.find('.finance-calculator-form__error-label').remove();
        closestGroup.removeClass('finance-calculator-form__error');
    };
    FinanceCalculatorService.prototype.addSpecificError = function (fieldName, message) {
        if (message === void 0) { message = ''; }
        var inputElement = $("input[name=" + fieldName + "]");
        var closestGroup = inputElement.closest('.finance-calculator-form__group');
        $(closestGroup).find('.finance-calculator-form__error-label').remove();
        $(closestGroup).addClass('finance-calculator-form__error').append('<div class="finance-calculator-form__error-label">' + message + '</div>');
    };
    FinanceCalculatorService.prototype.clearCalculatorErrors = function (event) {
        event.preventDefault();
        var field = event.target;
        var closestGroup = $(field).closest('.finance-calculator-form__group');
        // Remove error label and class
        closestGroup.find('.finance-calculator-form__error-label').remove();
        closestGroup.removeClass('finance-calculator-form__error');
    };
    FinanceCalculatorService.prototype.validateCalculatorError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        var closestGroup = field.closest('.finance-calculator-form__group');
        $(closestGroup).find('.finance-calculator-form__error-label').remove();
        $(closestGroup).addClass('finance-calculator-form__error').append('<div class="finance-calculator-form__error-label">' + message + '</div>');
    };
    FinanceCalculatorService.prototype.formatNumbers = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    };
    FinanceCalculatorService.prototype.updateLabel = function (paymentFrequency) {
        if (paymentFrequency === void 0) { paymentFrequency = 'MONTHLY'; }
        var approximatelyPTag = document.querySelectorAll('p.p-finance-access-monthly-repayment');
        var titleValue = (paymentFrequency === 'MONTHLY') ? 'New Estimated Monthly Repayment' : 'New Estimated Annual Repayment';
        [].slice.call(approximatelyPTag).forEach(function (p) {
            p.innerHTML = titleValue;
        });
    };
    return FinanceCalculatorService;
}());
export { FinanceCalculatorService };



//////////////////
// WEBPACK FOOTER
// ./services/finance-calculator.service.ts
// module id = 66
// module chunks = 0